import i18next from 'i18next';
var PATTERN_EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var validateEmailI18n = function validateEmailI18n(value) {
  return PATTERN_EMAIL.test(value) ? null : i18next.t('validation:email');
};
export default validateEmailI18n;